import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  menu: {
    marginTop: 0,
    '& .MuiPaper-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_600.main
          : theme.palette.common.white,
      borderRadius: 8,
      padding: '0'
    },
    '& .MuiList-padding': {
      padding: 0
    }
  },
  emojiButton: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    borderRadius: '50%',
    padding: '6px',
    width: 32,
    height: 32,
    transition: 'background-color 0.2s ease',
    fontFamily: 'Noto Color Emoji, sans-serif',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_500.main
          : theme.palette.gray_100.main
    }
  },
  emojiButtonMenu: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px',
    width: 32,
    height: 32,
    borderRadius: '50%',
    transition: 'all 0.2s ease',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.grey[600]
    // '&:hover': {
    //   backgroundColor:
    //     theme.palette.type === 'dark'
    //       ? theme.palette.dark_500.main
    //       : theme.palette.grey[100],
    //   color: theme.palette.blue_300.main
    // }
  },
  flexContainer: {
    display: 'flex',
    gap: '4px',
    // padding: '8px 12px',
    alignItems: 'center'
  }
}))
